import React from 'react';
import classNames from 'classnames';

import styles from './index.module.css';

interface IProps {
  text?: string;
}
const Loading: React.FC<IProps> = (props) => {
  const { text } = props;
  return (
    <div className={classNames(styles.module, styles.loading)}>
      <div className={styles.content}>
        <div className={styles.loadingIcon}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div className={styles.text}>{text ?? '加载中...'}</div>
      </div>
    </div>
  );
};

export default React.memo(Loading);
